import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';

import { IconButton } from '../../../components/icon_button';
import { BarChart4BarsIcon } from 'mastodon/components/icons/bar_chart';

const messages = defineMessages({
  add_poll: { id: 'poll_button.add_poll', defaultMessage: 'Add a poll' },
  remove_poll: { id: 'poll_button.remove_poll', defaultMessage: 'Remove poll' },
});

const iconStyle = {
  height: null,
  lineHeight: '27px',
};

class PollButton extends PureComponent {

  static propTypes = {
    disabled: PropTypes.bool,
    active: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    isComposeForm: PropTypes.bool
  };

  handleClick = () => {
    this.props.onClick();
  };

  render () {
    const { intl, active, disabled } = this.props;

    return (
      <div className={`compose-form__poll-button ${this.props.isComposeForm && 'compose-form___action-full'}`} onClick={this.props.isComposeForm && this.handleClick}>
        <IconButton
          icon='tasks'
          iconComponent={BarChart4BarsIcon}
          title={intl.formatMessage(active ? messages.remove_poll : messages.add_poll)}
          disabled={disabled}
          // onClick={this.handleClick}
          className={`compose-form__poll-button-icon ${active ? 'active' : ''}`}
          size={18}
          inverted
          style={iconStyle}
        />
        {this.props.isComposeForm && (
          <FormattedMessage
            id='compose.new_poll'
            defaultMessage='Create new poll'
          />
        )}
      </div>
    );
  }

}

export default injectIntl(PollButton);
